var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_67_3",
    "data-name": "Component 67 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 96 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 73,
    height: 73,
    rx: 8,
    fill: "#417eba"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8925",
    "data-name": "Group 8925",
    transform: "translate(-57.195 -706.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(91.048 737.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.58,285.221c-1.207-9.032.023-17.5,5.379-25.134a9.476,9.476,0,0,1,1.774-2s13.215.046,18.707.046C58.322,270.508,50.159,283.729,31.58,285.221Z",
    transform: "translate(-31.154 -250.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M49.547,255.322q.282,2.089.379,4.134c-7,0-7.933.054-14.356.054A32,32,0,0,1,49.547,255.322Z",
    transform: "translate(-22.999 -255.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M57.53,261.855,52.758,253.6l-11.574-3.346-11.238,3.109-5.111,8.494v23.414H40.369l1.079-4.88A20.4,20.4,0,0,1,53.39,266.021l4.14-1.757Z",
    transform: "translate(48.214 472.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M23.093,265.044l5.854-11.074,15.391-5.379,14.34,4.309,8.047,12.144",
    transform: "translate(45 469.409)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_close_24px",
    "data-name": "icon/navigation/close_24px",
    transform: "translate(53 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    fill: "#f6f6f6",
    stroke: "#545454",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 41,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 33,
    height: 33,
    transform: "translate(5 5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M20.364,2.051,18.313,0,10.182,8.131,2.051,0,0,2.051l8.131,8.131L0,18.313l2.051,2.051,8.131-8.131,8.131,8.131,2.051-2.051-8.131-8.131Z",
    transform: "translate(21.5 7.101) rotate(45)",
    fill: "#787878"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/ButtonIcon.2225c82ec6936c66124bade042bd1643.svg";
export { ForwardRef as ReactComponent };